import request from '@/utils/request'


// 共享设备总数
export function assetsTotal(data) {
  return request({
    url: '/db/screen/assets-total',
    method: 'post',
    data
  })
}


// 共享设备按名统计
export function assetsNameTotal(data) {
    return request({
        url: '/db/screen/assets-name-total',
        method: 'post',
        data
    })
}

// 设备使用时间排行
export function assetsUseTimeRank(data) {
  return request({
    url: '/db/screen/assets-use-time-rank',
    method: 'post',
    data
  })
}

// 获取系统里设备名称
export function assetsSort(data) {
  return request({
    url: '/db/screen/assets-sort',
    method: 'post',
    data
  })
}

// 查询设备分布状况
export function deptAssetsDistribute(data) {
  return request({
    url: '/db/screen/dept-assets-distribute',
    method: 'post',
    data
  })
}

// 逾期未归还查询
export function overdueReturnQuery(data) {
  return request({
    url: '/db/screen/overdue-return-query',
    method: 'post',
    data
  })
}

// 实时借出记录查询
export function realBorrowRecordQuery(data) {
  return request({
    url: '/db/screen/real-borrow-record-query',
    method: 'post',
    data
  })
}
